import { Box,Grid2,Typography,Button,Paper,InputBase } from "@mui/material"
import Styles from "./Web.module.css"
import pic from "../../../../ui-utils/latestPics/BrokerHome.svg"
import { backendHosts } from "../../../../ui-utils/apiConfig"
import { useState,useEffect } from "react"
import validator from "validator"
import { motion } from "framer-motion";
import axios from "axios"
import en from "../../../../i18n/English/Partner/home.json";
import hi from "../../../../i18n/Hindi/Partner/home.json";
import kn from "../../../../i18n/Kannada/Partner/home.json";
import ma from "../../../../i18n/Marathi/Partner/home.json";
import gu from "../../../../i18n/Gujarati/Partner/home.json";
import { useLanguage } from "../../../../Context/LangContext";
export default function BrokerWeb(){
    const [formData, setFormData] = useState({
        name: "",
        mobileNo: "",
        email: "",
    });
    const { language } = useLanguage();
      const translations = { en, hi, kn,ma,gu };
      const t = translations[language];

    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [errorField, setErrorField] = useState("");
    const [error, setError] = useState("");


    const [successMsg,setSuccessMsg]=useState("")
    const MotionGrid = motion(Grid2);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsFirstLoad(false); // disable animation after first render
        }, 1200); // match your longest animation duration (e.g., 1s)

        return () => clearTimeout(timer);
    }, []);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === "name") {
            updatedValue = value.replace(/[0-9]/g, "");
        }

        if (name === "mobileNo") {
            const numericValue = value.replace(/\D/g, "");
            updatedValue = numericValue.slice(0, 10);
        }

        setFormData((prev) => ({ ...prev, [name]: updatedValue }));

        // Clear error only for the field that has error
        if (name === errorField) {
            setError("");
            setErrorField("");
        }
    };


    const handleSubmit = async () => {
        if (formData.name.trim().length === 0) {
            setError("Please enter your name.");
            setErrorField("name");
            return;
        } else if (!/^[a-zA-Z\s]+$/.test(formData.name)) {
            setError("Name should only contain letters and spaces.");
            setErrorField("name");
            return;
        }

        if (formData.mobileNo.trim().length === 0) {
            setError("Please enter your mobile number.");
            setErrorField("mobileNo");
            return;
        } else if (!validator.isMobilePhone(formData.mobileNo, "en-IN")) {
            setError("Please enter a valid mobile number.");
            setErrorField("mobileNo");
            return;
        }

        if (formData.email.trim().length === 0) {
            setError("Please enter your email.");
            setErrorField("email");
            return;
        } else if (!validator.isEmail(formData.email)) {
            setError("Please enter a valid email address.");
            setErrorField("email");
            return;
        }

        setError("");
        setErrorField("");

        const payload = {
            data: {
                type: "broking partner",
                name: formData.name,
                email: formData.email,
                mobile: formData.mobileNo,
                description: "Requesting to become a partner with Tradeboss",
            },
        };

        const response = await axios.post(`${backendHosts.ADMIN}/api/ticket-tracker/tickets`, payload);

        if (response.data?.data?.status == 200) {
            setFormData({ name: "", mobileNo: "", email: "" });
            setSuccessMsg("Thank you for providing your details! Our team will reach out to you shortly.");
        } else {
            setError("Something went wrong. Please try again later.");
            setErrorField("email"); // or a general place
            setSuccessMsg("");
        }
    };


    return (
        <>
          <Grid2 className={Styles.outerBox}>
                {isFirstLoad ? (
                    <MotionGrid
                        initial={{ opacity: 0, x: -300 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
                    >
                        <img src={pic} alt="BrokerHome" className={Styles.pic} />
                    </MotionGrid>
                ) : (
                    <Grid2>
                        <img src={pic} alt="BrokerHome" className={Styles.pic} />
                    </Grid2>
                )}


            <Grid2 className={Styles.innerCard}>

                    {/* {isFirstLoad ? (
                        <MotionGrid
                            initial={{ opacity: 0, y: -300 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
                        >
                            <h1 className={Styles.heading}>
                                {t.title}
                            </h1>
                        </MotionGrid>
                    ) : (
                        <Grid2>
                            <h1 className={Styles.heading}>
                                {t.title}
                            </h1>
                        </Grid2>
                    )} */}



                    {isFirstLoad ? (
                        <MotionGrid
                            initial={{ opacity: 0, y: -300 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
                        >
                            <h1 className={Styles.heading}>
                                {t.title}
                            </h1>
                            <h1 className={Styles.heading}>
                              {t.heading}
                            </h1>
                        </MotionGrid>
                    ) : (
                        <Grid2>
                                <h1 className={Styles.heading}>
                                    {t.title}
                                </h1>
                            <h1 className={Styles.heading}>
                              {t.heading}
                            </h1>
                        </Grid2>
                    )}


                    {isFirstLoad ? (
                        <MotionGrid
                            initial={{ opacity: 0, x: 300 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
                        >
                            {/* Form content here */}
                            <Grid2 className={Styles.fieldCard}>
                                <Paper component="form" className={Styles.mobilefield}>
                                    <InputBase
                                        className={Styles.inputbase}
                                        name="name"
                                        placeholder={t.formFields.name.placeholder}
                                        onChange={handleInputChange}
                                        value={formData.name}
                                    />
                                </Paper>
                                {errorField === "name" && <Typography className={Styles.errMsgg}>{error}</Typography>}

                                <Paper component="form" className={Styles.mobilefield} sx={{marginTop:"16px"}}>
                                    <InputBase
                                        className={Styles.inputbase}
                                        name="mobileNo"
                                        placeholder={t.formFields.mobileNo.placeholder}
                                        onChange={handleInputChange}
                                        value={formData.mobileNo}
                                    />
                                </Paper>
                                {errorField === "mobileNo" && <Typography className={Styles.errMsgg}>{error}</Typography>}


                            </Grid2>

                            <Grid2 className={Styles.emailfieldCard}>
                                <Paper component="form" className={Styles.emailfield}>
                                    <InputBase
                                        className={Styles.emailinputbase}
                                        name="email"
                                        placeholder={t.formFields.email.placeholder}
                                        onChange={handleInputChange}
                                        value={formData.email}
                                    />
                                </Paper>
                                {errorField === "email" && <Typography className={Styles.errMsgg}>{error}</Typography>}


                                {/* {error ? (
                                    <Typography className={Styles.errMsgg}>{error}</Typography>
                                ) : (
                                    successMsg && (
                                        <Typography className={Styles.successMsg}>{successMsg}</Typography>
                                    )
                                )} */}
                                <Grid2 className={Styles.buttonCard}>
                                    <Button onClick={handleSubmit} className={Styles.dematButton}>
                                        {t.formFields.buttonText}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </MotionGrid>
                    ) : (
                        <Grid2>
                            <Grid2 className={Styles.fieldCard}>
                                    <Paper component="form" className={Styles.mobilefield}>
                                        <InputBase
                                            className={Styles.inputbase}
                                            name="name"
                                            type="name"
                                            placeholder={t.formFields.name.placeholder}
                                            autoComplete="name"
                                            inputProps={{
                                                "aria-label": "Name"
                                            }}
                                            onChange={handleInputChange}
                                            value={formData.name}
                                        />
                                    </Paper>
                                    {errorField === "name" && <Typography className={Styles.errMsgg}>{error}</Typography>}


                                    {/* <Paper component="form" className={Styles.mobilefield} sx={{ marginTop: "16px" }}>
                                        <InputBase
                                            className={Styles.inputbase}
                                            name="mobileNo"
                                            placeholder={t.formFields.mobileNo.placeholder}
                                            onChange={handleInputChange}
                                            value={formData.mobileNo}
                                        />
                                    </Paper> */}
                                    <Paper
                                        component="form"
                                        className={Styles.mobilefield}
                                        sx={{ marginTop: "16px" }}
                                    >
                                        <InputBase
                                            className={Styles.inputbase}
                                            name="mobileNo"
                                            type="tel"
                                            placeholder={t.formFields.mobileNo.placeholder}
                                            autoComplete="tel"
                                            inputProps={{
                                                "aria-label": "Phone Number",
                                                inputMode: "numeric",
                                            }}
                                            onChange={handleInputChange}
                                            value={formData.mobileNo}
                                        />
                                    </Paper>
                                    {errorField === "mobileNo" && <Typography className={Styles.errMsgg}>{error}</Typography>}


                            </Grid2>

                            <Grid2 className={Styles.emailfieldCard}>
                                    <Paper component="form" className={Styles.emailfield}>
                                        <InputBase
                                            className={Styles.emailinputbase}
                                            name="email"
                                            type="email"
                                            placeholder={t.formFields.email.placeholder}
                                            autoComplete="email"
                                            inputProps={{
                                                "aria-label": "email"
                                            }}
                                            onChange={handleInputChange}
                                            value={formData.email}
                                        />
                                    </Paper>
                                    {errorField === "email" && <Typography className={Styles.errMsgg}>{error}</Typography>}
                                   { (!error && successMsg) && (
                                    <Typography className={Styles.successMsg}>{successMsg}</Typography>
                                    )}

                                {/* {error ? (
                                    <Typography className={Styles.errMsgg}>{error}</Typography>
                                ) : (
                                    successMsg && (
                                        <Typography className={Styles.successMsg}>{successMsg}</Typography>
                                    )
                                )} */}
                                <Grid2 className={Styles.buttonCard}>
                                    <Button onClick={handleSubmit} className={Styles.dematButton}>
                                        {t.formFields.buttonText}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    )}



                    {isFirstLoad ? (
                        <MotionGrid
                            initial={{ opacity: 0, y: 300 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1, delay: 0.2, ease: "easeInOut" }}
                        >
                            <Typography className={Styles.txt}>
                                {t.contactInfo.text}
                            </Typography>
                            <Typography className={Styles.txt}>
                                Phone: +91 74003 62816 | Email: info@tradeboss.co
                            </Typography>
                        </MotionGrid>
                    ) : (
                        <Grid2>
                            <Typography className={Styles.txt}>
                                {t.contactInfo.text}
                            </Typography>
                            <Typography className={Styles.txt}>
                                Phone: +91 74003 62816 | Email: info@tradeboss.co
                            </Typography>
                        </Grid2>
                    )}



                </Grid2>

          </Grid2>
        </>
    )
}